import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["srcset"]
const _hoisted_2 = ["srcset"]
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = ["src", "alt"]

import { PropType } from "vue";
import { IResponsiveImagesModel } from "@/models/IResponsiveImagesModel";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressResponsivePicture',
  props: {
  pictures: {
    type: Object as PropType<IResponsiveImagesModel>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.pictures)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["responsive-picture", { 'responsive-picture--hover': __props.pictures.hover?.url }])
      }, [
        _createElementVNode("picture", null, [
          (__props.pictures.desktop)
            ? (_openBlock(), _createElementBlock("source", {
                key: 0,
                srcset: __props.pictures.desktop.url,
                media: "(min-width: 992px)"
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true),
          (__props.pictures.tablet)
            ? (_openBlock(), _createElementBlock("source", {
                key: 1,
                srcset: __props.pictures.tablet.url,
                media: "(min-width: 576px)"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          (__props.pictures.mobile)
            ? (_openBlock(), _createElementBlock("source", {
                key: 2,
                srcset: __props.pictures.mobile.url
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          (__props.pictures.desktop)
            ? (_openBlock(), _createElementBlock("img", {
                key: 3,
                alt: __props.pictures.desktop.alt,
                src: __props.pictures.desktop.url,
                class: "responsive-picture__image"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        (__props.pictures.hover?.url)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.pictures.hover.url,
              alt: __props.pictures.hover.alt,
              class: "responsive-picture__image--hover"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})